module.exports = __webpack_public_path__ + "img/889.4d3b7e72.png";